import api from "../../../services/api";

const APIS = {
    GET_SHIPPING_DETAILS: "/Sample/requestfeedAssay",
    PRINT_SAMPLES_PDF: "/Sample/getsamplespdfbytes",
    EDIT_SAMPLE: "/Sample/edit-assigned-sample-to-customer",
    GET_SHIPPING_DETAILS_Sample_Id: "/Sample/requestfeedAssayBySampleId"
};

export const getShippingDetails = async (groupId) => {
    try {
        const response = await api.get(`${APIS.GET_SHIPPING_DETAILS}?groupId=${groupId}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch shipping details:', error);
        throw error;
    }
};

export const getShippingDetailsBySample = async (sampleId) => {
    try {
        const response = await api.get(`${APIS.GET_SHIPPING_DETAILS_Sample_Id}?sampleId=${sampleId}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch shipping details:', error);
        throw error;
    }
};

export const printSamplesPDF = async (samples, groupIds) => {
    try {
        let url;

        if (samples.length <= 2) {
            const ids = samples.map(s => s.sampleId).join('&ids=');
            url = `${APIS.PRINT_SAMPLES_PDF}?ids=${ids}`;
        } else {
            const groupIdsArray = Array.isArray(groupIds) ? groupIds : [groupIds];
            const groupIdsParams = groupIdsArray.map(id => `groupIds=${id}`).join('&');
            url = `${APIS.PRINT_SAMPLES_PDF}?${groupIdsParams}`;
        }

        const response = await api.get(url);

        let pdfData;
        if (typeof response.data === 'string') {
            pdfData = atob(response.data);
        } else {
            pdfData = response.data;
        }

        const bytes = new Uint8Array(pdfData.length);
        for (let i = 0; i < pdfData.length; i++) {
            bytes[i] = pdfData.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: 'application/pdf' });
        const pdfUrl = window.URL.createObjectURL(blob);

        const printWindow = window.open(pdfUrl, '_blank', 'width=900,height=700,scrollbars=yes,resizable=yes');

        if (printWindow) {
            printWindow.onload = () => {
                setTimeout(() => {
                    printWindow.focus();
                    printWindow.print();
                }, 1000);
            };

            printWindow.onbeforeunload = () => {
                window.URL.revokeObjectURL(pdfUrl);
            };
        } else {
            alert('Please allow popups for this site to print the PDF');
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = `samples_multiple_groups.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(pdfUrl);
        }

        return response.data;
    } catch (error) {
        console.error('Failed to print samples PDF:', error);
        throw error;
    }
};

export const formatShippingData = (apiData) => {
    return apiData.map((item, index) => ({
        sampleId: item.sampleId?.toString() || "",
        controlId: item.customerId || "",
        companyName: item.companyName || "",
        location: item.locationName || "",
        specialLevel: item.expectedLevel || "",
        expectedAssay: item.productType || "",
        productType: item.productType || "",
        lotNo: item.lotNumber || "",
        groupId: item.groupId?.toString() || "",
        unit: item.unitName || "",
        species: item.speciesType || "",
        barcodeNumber: item.barCodeNumber || "",
        base64Barcode: item.base64Barcode || "",
        status: item.status || "",
        date: item.date || "",
        index: item.index || index + 1
    }));
};
